<div class="page-wrapper">
    <div class="header">
        <app-header
                [headerText]="'CMS.EDUCATION.TILE_TITLE' | translate"
                [headerParagraph]="'CMS.EDUCATION.DESCRIPTION' | translate"
                [backButtonDisplayed]="true"
                [backButtonLabel]="'GENERAL.BACK' | translate"
                [leaveButton]="true"
                [leaveButtonLabel]="'GENERAL.LOGOUT' | translate"
                (buttonEvent)="backButtonAction()"
                (leaveIndication)="onLogOut()">
        </app-header>
    </div>
    <div role="main" class="content">
        <div class="two-column-layout indication-section" *ngIf="indications.length > 0">
            <ng-container *ngFor="let indication of indications">
                <app-card
                        [disabled]="false"
                        [showDropdownActions]="true"
                        [tabindex]="1"
                        [cardPadding]="'32'"
                        [cardInfo]="true"
                        [cardInfoTitleIcon]="'eye'"
                        [cardInfoTitle]="indication.indicationSpecialty | indicationSpecialtyTranslation"
                        [cardMainTitle]="indication.title"
                        [cardParagraph]="indication.description"
                        [ariaLabel]="indication.title + ('GENERAL.DIAGNOSIS' | translate)"
                        [triggerData]="triggerData"
                        [menuItems]="menuItems"
                        (buttonEvent)="buttonActions($event, indication.id)"
                        (cardClickEvent)="onOpenIndication(indication.id)">
                </app-card>
            </ng-container>
        </div>

        <div class="content__no-indications" *ngIf="indications.length === 0">
            <img src="/assets/images/no_indications.png">
            <h3>{{'CMS.EDUCATION.NO_INDICATIONS_TITLE' | translate}}</h3>
            <p>{{'CMS.EDUCATION.NO_INDICATIONS_DESCRIPTION' | translate}}</p>
        </div>
    </div>
    <div class="footer btn-wrapper">
        <div class="footer-content">
            <div class="btn-wrapper">
                <app-button
                        [cssClasses]="'btn regular full-width solid__blue-07'"
                        (buttonClicked)="onAddNewIndication()">
                    {{'GENERAL.ADD_NEW' | translate}}
                </app-button>
            </div>
        </div>
    </div>
</div>
